import { render, staticRenderFns } from "./Masterclasses.vue?vue&type=template&id=5e345dbf&"
import script from "./Masterclasses.vue?vue&type=script&lang=js&"
export * from "./Masterclasses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports